import { IPage } from '../../interfaces'
import Table from '../form/Table.tsx'
import { context } from '../../index.js';
import { observer } from 'mobx-react-lite';
import FormFields from '../form/FormFields.tsx';
import TableOpen from '../form/TableOpen.tsx';

interface IPageProps {
    page: IPage;
}

export default observer(function Page ({page}: IPageProps) {

    const title = context.formatLabel(page.title)
    const description = context.formatLabel(page.description)

    return (
        <div className="questionnaire-page">
            <h2>{title}</h2>

            {description && !description.includes("{") ? <div dangerouslySetInnerHTML={{__html: description}}></div> : null}

            {page.fields ? (
                <FormFields 
                    submitButtonText={context.showSettings ? "Save settings" : "Next"}
                    initialValues={{...context.preloadedAnswers, ...context.answers}} 
                    fields={page.fields} 
                    onChange={(formik) => {
                        context.unsubmittedValues = formik.values
                    }}
                    onSubmit={(values) => {
                        context.submitPageAnswers(values)
                    }} />
            ) : null}

            {page.table ? (
                <div>
                    {page.table.style === "open" ? (
                        <TableOpen
                            table={page.table} 
                            onSubmit={(values) => {
                                context.submitPageAnswers(values)
                            }} /> 
                    ) : (
                        <Table 
                            table={page.table} 
                            onSubmit={(values) => {
                                context.submitPageAnswers(values)
                            }} /> 
                    )}
                </div>
            ) : null}
        </div>
    )
})